import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-hotelfilter',
    templateUrl: './hotelfilter.component.html',
    styleUrls: ['./hotelfilter.component.scss'],
    standalone: false
})
export class HotelfilterComponent implements OnInit {
    mode = input<string>('');
    type = input<string>('');
    realparams = input<ParamFilters>(null);
    reference = input<string>('');
    israiltravel = input<boolean>(false);
    completion = input<any>(null);


    isBrowser = signal<boolean>(false);
    showMore = signal<boolean>(false);
    showDate = signal<boolean>(false);
    smallVersion = signal<boolean>(true);


    btntext = signal<string>('Urlaub finden');
    start = signal<string>('');
    end = signal<string>('');
    filter = signal<ParamFilters>(null);
    mindauer = signal<number>(-1);
    maxdauer = signal<number>(-1);
    local_type = signal<string>('');

    destroyRef = inject(DestroyRef);

    constructor(
        protected mediaService: MediaService,
        protected hotelFilters: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.local_type.set(this.type());
        this.btntext.set(this.type() === 'hotelonly' ? 'Hotel finden' : 'Urlaub finden');
        this.initFilters();
        this.initFilterSub();
    }

    gotoZiel(gotourl): void {
        this.smallVersion.set(true);
        this.hotelFilters.setIsReilTravel(this.type() === 'railtravel');
        this.hotelFilters.setReference(this.reference);
        if (gotourl) {
            this.hotelFilters.gotoUrl(this.type());
        } else {
            this.hotelFilters.changeUrlByType(this.type);
        }
    }

    initFilterSub(): void {
        this.hotelFilters.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            // console.log(filter)
            if (filter?.reisezeitraumResult) {
                this.filter.set(JSON.parse(JSON.stringify(filter)));
                this.initDate(filter);
            }
        });
    }

    async setBahn() {
        this.local_type.set('railtravel');
        this.hotelFilters.onlySetProductType('railtravel');
    }

    async setPauschal() {
        this.local_type.set('pauschal');
        this.hotelFilters.onlySetProductType('pauschal');
    }

    async setHotelonly() {
        this.local_type.set('hotelonly');
        this.hotelFilters.onlySetProductType('hotelonly');
    }

    async initDate(filter) {
        this.showDate.set(false);
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start.set(moment().add(tmp[0], 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD'));

            this.mindauer.set(Number(tmp[0]));
            this.maxdauer.set(17);

        } else {
            if (filter?.reisezeitraumResult?.start?.length > 0) {
                if (moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                    this.start.set(moment().add(4, 'days').format('YYYY-MM-DD'));
                    this.end.set(moment().add(180, 'days').format('YYYY-MM-DD'));
                } else {
                    this.start.set(moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD'));
                    this.end.set(moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD'));
                }
            } else if (!isNaN(Number(filter?.reisezeitraumResult?.start))) {
                this.start.set(moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD'));
                this.end.set(moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD'));
            } else {
                this.start.set(moment().add(4, 'days').format('YYYY-MM-DD'));
                this.end.set(moment().add(180, 'days').format('YYYY-MM-DD'));
            }

            if (filter?.reisezeitraumResult?.minDuration) {
                this.mindauer.set(Number(filter?.reisezeitraumResult?.minDuration));
            }
            if (filter?.reisezeitraumResult?.maxDuration) {
                this.maxdauer.set(Number(filter?.reisezeitraumResult?.maxDuration));
            } else if (this.mindauer()) {
                this.maxdauer.set(this.mindauer());
            }
        }
        // console.log(this.mindauer())
        this.showDate.set(true);
    }

    showMBMenu(): void {
        this.smallVersion.set(false);
    }

    openclosemore(): void {
        this.showMore.set(!this.showMore());
        if (!this.showMore()) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        if (this.realparams()) {
            this.hotelFilters.onlySetRealParams(this.realparams());
        } else if (this.mode() === 'home') {
            this.hotelFilters.resetAllExtrasHome();
        }
    }

    async switchTo(productType) {
        this.local_type.set(productType);
        this.hotelFilters.setProductType(productType);
    }

    selectValue(ev): void {
        this.hotelFilters.zeitanddauer(ev);
    }

    async resTraveler(ev) {
        this.hotelFilters.reisendeResult(ev);
    }
}
